module.exports = __webpack_public_path__ + "878cd95b8b79daf09f6a9f891943af0b.jpg";